import { parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export function parseDate(date: string, tz = 'UTC') {
  return utcToZonedTime(parseISO(date), tz);
}
